var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notif_bell",
    "data-name": "notif bell",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 21,
    height: 24,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAYAAAAVibZIAAABv0lEQVQ4ja2VPWsVQRSGnyQaUSOaIkj8aNIEQqJgIWJlYamFBBHEQkSxyY8IdgF7wZ9gY2ETYmGREJJOsBEVRTEkELlG/Ew0PDK5Z3G8XLN317xwmJ2zOw9n3jnMopbFqDqtflNfqDfK1pQBB9S3NvVQfRPPl/8HejUgt9UedUj9qM7VhXap9wK6rH5RV9RfUf1gVeiYOh/ANXUhtv84s6Oh3uwUeiZASZPq0Zb3+9VLcWhJd8qgh9Ul9bN6rsTv/qjc8P6f0MLD8Q5aLcUh9V14fbAd9Ii6rj7pEFjEtaxDtnLd/NFZoBe4TzU9Ar4CF4tVOXQsxmcVoZ+A58BwwcuhfTH+qAgtwPuA3a1Qa8AKdeWT7m0/ramdqvQvtYPWqX5XWPAzBySTLwBrQKMG9CUwCJxvltds2Klo4FsVG7+I43HBvFL7UuK0uqnOxHVXJ4gbK+luSjwFTgIfot8KS5LH38OrvdlWk28bwJ7wMj+TofQuJRfCy9S4PdlHaX4KWAfmY74JHANGgffAUgs05RplXs3GJXNFPaCOqIthV3qu9Y8aVl+HVxsxJk1st27L5BINANeBE8Aq8CAsay/gN6F8l4k5eJ2DAAAAAElFTkSuQmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifBell);
export default __webpack_public_path__ + "static/media/notif_bell.a801b4d1.svg";
export { ForwardRef as ReactComponent };